import PropTypes from "prop-types";
import ErrorMessage from "../Errors/ErrorMessage";
import { useFormikContext } from "formik";

const Number = ({
  title,
  name,
  className,
  serverError,
  formikOnChange = true,
  onChange,
  defaultValue = false,
  labelClass = "",
  disabled = false,
}) => {
  const { errors, handleChange, values } = useFormikContext();

  return (
    <div className='form-group'>
      <label
        className={`f-13 text-left d-flex flex-row justify-content-start ${labelClass}`}
      >
        {title}
      </label>
      <input
        disabled={disabled}
        type='number'
        name={name}
        value={defaultValue === false ? values[name] : defaultValue}
        onChange={(e) => {
          if (!disabled) {
            formikOnChange ? handleChange(e) : onChange(e.target.value);
          }
        }}
        className={`form-control ${className}`}
      />
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

Text.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  serverError: PropTypes.any,
  formikOnChange: PropTypes.bool,
  onChange: PropTypes.func,
  labelClass: PropTypes?.string,
  disabled: PropTypes.bool,
};

export default Number;
